import { useNavigate,  generatePath, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { logoutUser } from "../store/slices/UserSlice";
//import { useState } from "react";
import mem from "../assets/img/member.png";
import pro from "../assets/img/property.png";
import lout from "../assets/img/logout.png";
import lead from "../assets/img/lead.png";
// import fra from "../assets/img/Frame.png";
import insplogo from "../assets/img/inspectionlogo.png";
import adminlogo from "../assets/img/adminlogo.png";
import qrcodelogo from "../assets/img/qrcode1.png";
// import clientProfile from "../assets/img/ClientProfile.png";
const SidebarIcons = () => {
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  //const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`sideNavBar showIcons overflow-x-auto mobile-bottom-navbar`}
      style={{
        width: "68px",
        //marginTop: "88px"
        marginTop: "58px",
      }}
    >
      {/* <div className="mb-5 ">
        <img src={finallogo} className="finalsidelogo" alt="logo" />
        <img
          src={sidebarlogo}
          className="sidelogo"
          alt="logo"
          //onClick={() => setIsOpen(!isOpen)}
          onClick={onToggle}
          style={{ cursor: "pointer" }}
        />
      </div> */}
      {/* <ul className="navbar-nav">
        <li className="nav-item mt-0 my-3">
          <a
            className="nav-link active"
            aria-current="page"
            href="/property-form"
          >
            <i className="fa-solid fa-house"></i>Dashboard
          </a>
        </li>
      </ul> */}
      {/* <p className="fs-6 fw-semibold mt-2 mb-2 text-start">ACCOUNT PAGES</p> */}
      <ul className="navbar-nav" style={{ marginTop: "22px" }}>
        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link  p-0" aria-current="page" href="#">
            <i className="fa-solid fa-user"></i>Profile
          </button>
        </li> */}
        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button
            className="nav-link p-0"
            aria-current="page"
            onClick={() => {
              navigate(
                  generatePath("/client/:clientNameParam/myBooking", {
                    clientNameParam,
                  })
                );
            }}
          >
            <i className="fa-solid fa-calendar"></i>My Bookings
          </button>
        </li> */}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/ClientBranding", {
                    clientNameParam,
                  })
                );
              }}
              title="Client Profile"
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Members</span> */}
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/members", {
                    clientNameParam,
                  })
                );
              }}
              title="Members"
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={mem} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Members</span> */}
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/addProperty", {
                    clientNameParam,
                  })
                );
              }}
              title="Properties"
            >
              <img src={pro} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Properties</span> */}
            </button>
          </li>
        )}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{marginLeft: "10px"}}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/subscription", {
                    clientNameParam,
                  })
                );
              }}
            >
              <i className="fa-solid fa-credit-card"></i>Subscription
            </button>
          </li>
        )} */}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/inspectionDashboard", {
                    clientNameParam,
                  })
                );
              }}
              title="Inspection Dashboard"
            >
              <img src={insplogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Inspection</span> */}
            </button>
          </li>
        )}

        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/leadDashboard", {
                    clientNameParam,
                  })
                );
              }}
              title="Lead Dashboard"
            >
              <img src={lead} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Lead</span> */}
            </button>
          </li>
        )}

        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-sign-in"></i>Sign In
          </button>
        </li>
        <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-rocket"></i>Sign Up
          </button>
        </li> */}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/QRCodes", {
                    clientNameParam,
                  })
                );
              }}
              title="Generate QR Code"
            >
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
              
            </button>
          </li>
        )} */}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/adminDashboard", {
                    clientNameParam,
                  })
                );
              }}
              title="Admin Dashboard"
            >
              <img src={adminlogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Admin</span> */}
            </button>
          </li>
        )}

        <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
          <button
            className="nav-link p-0"
            aria-current="page"
            onClick={() =>
              dispatch(
                logoutUser({
                  userId: userObj?.userId,
                  userIdentifier: userObj?.userEmail,
                })
              )
            }
            title="Sign Out"
          >
            <img src={lout} className="sidelogo" alt="logo" />
            {/* <span className="menu-text">Sign Out</span> */}
          </button>
        </li>
      </ul>
      {/* <div className="menu_info_card mt-3">
        <div className="col-12 mb-3 ">
          <img src={fra} className="sidelogo" alt="logo" />
        </div>
        <div className="col-12 mb-3">
          <p className="fs-6 fw-semibold mb-4">Need Help?</p>
          <p className="fw-semibold mb-4" style={{ fontSize: "0.7rem" }}>
            Please check our documentation or connect with support.
          </p>
        </div>
        <div className="col-12">
          <button
            type="button"
            className="btn btn-light w-100"
            style={{ backgroundColor: "#E85D04" }}
          >
            Documentation
          </button>
          <button
            type="button"
            className="btn btn-light w-100 mt-2"
            style={{ backgroundColor: "#E85D04", fontSize: "10px" }}
          >
            Connect with Support
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default SidebarIcons;
